module.exports = __webpack_public_path__ + "img/pasaporte.0f368dad.png";